import * as React from 'react'
import * as Yup from 'yup'
import * as rt from '../../config/routeType'
import { Formik, Form } from 'formik'
import { useSelector, useDispatch } from 'react-redux'
import { setIsStored } from '../../redux/slices/Alerts'
import { setUsername } from '../../redux/slices/Auth/login'
import { styled } from '@mui/material/styles'
import { Grid, Box, Button, IconButton, Stack } from '@mui/material'
import { Typography as MIUTypography, InputAdornment } from '@mui/material'
import { Lock, AccountCircle, Visibility, VisibilityOff } from '@mui/icons-material'
import { updateUser } from '../../services'

import { schema } from '../../utils/schemaValidation'
import { getUserMe } from '../../services'
import AlertCustom from '../../components/Alerts'

import Textfield from '../../components/FormsUI/Textfield'

const BUTTON_COLOR = 'var(--color-green-light)'
const TEXT_BUTTON_COLOR = '#EDEEFF'
const FONTFAMILYTYPE = 'var(--font-family)'

const Typography = styled(MIUTypography)(props => ({
  fontFamily: FONTFAMILYTYPE,
  fontStyle: 'normal',
  fontSize: '1.125em',
  fontWeight: props.istitle ? 700 : 450,
  lineHeight: props.istitle ? '24px' : '24px',
  color: props.istitle ? '#1B1C37' : '#6A6A6A',
  textAlign: 'center',
}))

const ButtonCustom = styled(Button)({
  height: '2em',
  backgroundColor: BUTTON_COLOR,
  textTransform: 'capitalize',
  fontFamily: 'Avenir Next',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '22px',
  color: TEXT_BUTTON_COLOR,
  fontSize: '16px',
  '&:hover': {
    backgroundColor: '#0fa73d',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: BUTTON_COLOR,
    borderColor: BUTTON_COLOR,
  },
})

const styleStack = {
  justifyContent: 'center',
  direction: 'column',
  alignItems: 'center',
  py: 2,
  px: '8vw',
  height: '100%',
  spacing: 2,
  width: '100%',
}

const boxStyle = {
  maxWidth: '500px',
  display: 'flex',
  flexDirection: 'column',
  bgcolor: 'background.paper',
  boxShadow: 14,
  pb: '50px',
  px: '25px',
  textAlign: 'center',
  borderRadius: '14px',
  overflowY: 'auto',
}

const ProfilePage = () => {
  const dispatch = useDispatch()
  const alertRef = React.useRef()
  const [showPassword, setShowPassword] = React.useState(false)
  const [updated, setUpdated] = React.useState(false)
  const [INITIAL_FORM_STATE, SET_INITIAL_FORM_STATE] = React.useState()
  const _state = useSelector(state => state.drawerLeft)
  const { isStored } = useSelector(state => state.alertsGlobal)
  const TOKEN = `Bearer ${window.localStorage.getItem('arbolQR_Token')}`

  const FORM_VALIDATION = Yup.object().shape({
    ...schema.USERNAME,
    ...schema.LASTNAME,
    ...schema.EMAIL,
    ...schema.PASSWORD,
    ...schema.PASSWORD_CONFIRMATION,
  })

  const styleBox = {
    backgroundColor: '#0000008a',
    marginLeft: _state.open ? _state.drawerWidth : 0,
    marginTop: _state.drawerHeight,
    height: _state.contentBox,
    width: 'inherit',
  }

  const handleClickShowPassword = () => setShowPassword(!showPassword)
  const handleMouseDownPassword = event => event.preventDefault()

  const handleClickLogin = async ({ username, lastname, email, password }) => {
    let resultSave = { stored: true }
    const data = {
      nombre: username,
      apellido: lastname,
      email,
      contrasena: Boolean(password) ? password : undefined,
    }

    const response = await updateUser(data, TOKEN)
    if (!response?.update) {
      return { stored: false, message: response?.message }
    }
    setUpdated(true)
    return resultSave
  }

  React.useEffect(() => {
    if (INITIAL_FORM_STATE) return
    getUserMe(TOKEN)
      .then(data => {
        const { user } = data
        SET_INITIAL_FORM_STATE({
          username: user?.nombre ?? '',
          lastname: user?.apellido ?? '',
          email: user?.email ?? '',
          password: '',
          password_confirmation: '',
        })
      })
      .catch(err => console.log('Error :>> ', err))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [INITIAL_FORM_STATE])

  React.useEffect(() => {
    if (!Boolean(isStored)) return
    dispatch(setUsername(null))
    alertRef?.current?.openAlert(true)
    alertRef?.current?.goRute(`/${rt.TREE}`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isStored])

  if (!INITIAL_FORM_STATE) return

  return (
    <Box component="div" style={styleBox}>
      <Stack {...styleStack}>
        <Box sx={boxStyle}>
          <Box pt={3}>
            <Typography istitle="true">Actualizar Datos</Typography>
          </Box>
          <Box pt={3}>
            <Formik
              initialValues={{ ...INITIAL_FORM_STATE }}
              validationSchema={FORM_VALIDATION}
              onSubmit={async values => {
                const itsStored = await handleClickLogin(values)
                dispatch(setIsStored(itsStored))
              }}>
              <Form>
                <Grid container spacing={2} sx={{ pt: 0, width: '100%', ml: 0 }}>
                  <Grid item xs={6} style={{ paddingLeft: 0, paddingRight: 4 }}>
                    <Textfield name="username" label="Nombre" />
                  </Grid>
                  <Grid item xs={6} style={{ paddingLeft: 4 }}>
                    <Textfield name="lastname" label="Apellido" />
                  </Grid>
                  <Grid item xs={12} style={{ paddingLeft: 0 }}>
                    <Textfield
                      name="email"
                      label="Ingrese su correo electrónico"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AccountCircle />
                          </InputAdornment>
                        ),
                      }}
                      placeholder="user@example.com"
                    />
                  </Grid>
                  <Grid item xs={12} style={{ paddingLeft: 0 }}>
                    <Textfield
                      name="password"
                      label="Contraseña"
                      type={showPassword ? 'text' : 'password'}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Lock />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end">
                              {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      placeholder="Nueva contraseña"
                    />
                  </Grid>
                  <Grid item xs={12} style={{ paddingLeft: 0 }}>
                    <Textfield
                      name="password_confirmation"
                      label="Confirmar contraseña"
                      type={showPassword ? 'text' : 'password'}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Lock />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end">
                              {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      placeholder="Vuelva a ingresar la contraseña"
                    />
                  </Grid>
                  <Grid item xs={12} style={{ paddingLeft: 0 }}>
                    <ButtonCustom
                      variant="contained"
                      fullWidth
                      type="submit"
                      disabled={updated}>
                      Actualizar
                    </ButtonCustom>
                  </Grid>
                </Grid>
              </Form>
            </Formik>
          </Box>
        </Box>
      </Stack>
      <AlertCustom
        ref={alertRef}
        severity={isStored?.stored !== true ? 'warning' : 'success'}>
        {isStored?.stored !== true ? isStored?.message : 'Guardado exitosamente.'}
      </AlertCustom>
    </Box>
  )
}

export default ProfilePage
